// import React, { useState, useEffect } from 'react';
// import {
//     Card,
//     Grid,
//     TextField,
//     InputAdornment,
//     Tooltip,
//     IconButton,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     TablePagination,
//     Typography,
//     Box,
//     CircularProgress,
//     useTheme,
//     useMediaQuery
// } from '@mui/material';
// import { Search } from '@mui/icons-material';
// import dayjs from 'dayjs';

// import CardHeadMenu from '../Components/Card/CardHeadMenu/CardHeadMenu';
// import CustomDateRangePicker from "../Components/DatePicker/CustomDateRangePicker";

// import pdfImage from "../Components/Assets/images/pdf.jfif";
// import excelImage from "../Components/Assets/images/excel.png";
// import configServ from '../services/config';
// import { useSelector } from 'react-redux';
// import DownloadAttendanceReportPdf from '../Components/Download/ DownloadAttendanceReportPdf';
// import DownloadAttendanceReportExcel from '../Components/Download/DownloadAttendanceReportExcel';
// import DownloadEmployeeAttendanceReportPdf from '../Components/Download/DownloadEmployeeAttendanceReportPdf';

// // Dummy Imports (Apne path ke hisab se verify kar lein)
// // import configServ from "../services/configServ"; 

// const AttendanceReport = () => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Mobile/Tablet check

//     // State Management
//     const [attendanceData, setAttendanceData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [searchCustomer, setSearchCustomer] = useState('');
//     const { user_id, company_id, is_super, companyName } = useSelector(
//         (state) => state.GlobalVariables,
//     );
//     // Default Date: 1st day of current month to Today
//     const [dateRange, setDateRange] = useState([
//         dayjs().startOf('month'),
//         dayjs()
//     ]);

//     // Frontend Pagination States
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(10);

//     const [companyLogo, setCompanyLogo] = useState("");
//     const [openBackdrop, setOpenBackdrop] = useState(false);

//     const assignCompanyLogo = async () => {
//         try {
//             const result = await configServ.company_logo({ company_id: company_id });
//             if (result && result.image) {
//                 // Assuming the result.image is already a base64 string
//                 setCompanyLogo(`data:image/png;base64,${result.image}`);
//             } else {
//                 setCompanyLogo(null); // Set as null if no logo
//             }
//         } catch (e) {
//             console.log(e);
//             setCompanyLogo(null); // Handle error by clearing logo
//         }
//     };

//     useEffect(() => {
//         assignCompanyLogo();
//     }, [company_id]);

//     const fetchAttendanceReports = async () => {
//         setLoading(true);
//         try {
//             // API payload schema as per your function
//             const response = await configServ.getAttendanceReports({
//                 company_id: company_id,
//                 start_date: dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : "",
//                 end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
//                 search: searchCustomer,
//             });

//             if (response && response.status) {
//                 setAttendanceData(response.data.data || response.data); // handles both formats
//             }
//         } catch (error) {
//             console.error("Error:", error);
//             setAttendanceData([]);
//         } finally {
//             setTimeout(() => setLoading(false), 500);
//         }
//     };

//     // Trigger API on dependencies change
//     useEffect(() => {
//         fetchAttendanceReports();
//         setPage(0); // Reset page whenever filters change
//     }, [dateRange, searchCustomer]);

//     // Pagination Handlers
//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };

//     // Button Handlers
//     const handleDownloadPdf = () => {
//         DownloadAttendanceReportPdf(attendanceData, companyName, companyLogo, setOpenBackdrop, dateRange);
//     };
//     const handleDownloadExcel = () => {
//         DownloadAttendanceReportExcel(attendanceData, companyName, companyLogo, setOpenBackdrop, dateRange);
//     };

//     // Frontend local pagination logic
//     const paginatedData = attendanceData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

//     const handleDownloadSingleEmployeePdf = async (employeeData) => {
//         try{
//             setOpenBackdrop(true);
//             const payload = {
//                 company_id: company_id,
//                 employee_id: employeeData.employee_id,
//                 start_date: dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : "",
//                 end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
//             };
//             const response = await configServ.employeeAttendanceReport(payload);
//             if(response.status === 200)
//             {
//                 DownloadEmployeeAttendanceReportPdf(response, companyName, companyLogo, setOpenBackdrop, dateRange);
//             }

//         } catch (error) {
//             console.error("Error:", error);
//             alert("Failed to download employee attendance report");
//         } finally {
//             setOpenBackdrop(false);
//         }
//     };

//     return (
//         <Box sx={{ p: 2, width: '100%' }}>
//             <CardHeadMenu
//                 prefix={"Na"}
//                 suffix={"Na"}
//                 title={"ATTENDANCE Reports"}
//                 showCreate={false}
//             />

//             {/* Top Filter Header Card */}
//             <Card
//                 sx={{
//                     p: 2,
//                     mb: 3,
//                     borderRadius: "12px",
//                     borderLeft: "6px solid #1976d2",
//                     width: "100%",
//                     boxShadow: 2
//                 }}
//             >
//                 <Grid container spacing={2} alignItems="center">
//                     {/* Search Field */}
//                     {/* <Grid item xs={12} sm={6} md={4}>
//                         <TextField
//                             fullWidth
//                             label="Search Employee"
//                             size="small"
//                             value={searchCustomer}
//                             onChange={(e) => setSearchCustomer(e.target.value)}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <Search fontSize="small" />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                         />
//                     </Grid> */}

//                     {/* Date Range Picker */}
//                     <Grid item xs={12} sm={6} md={4}>
//                         <CustomDateRangePicker
//                             value={dateRange}
//                             onChange={setDateRange}
//                             fullWidth
//                         />
//                     </Grid>

//                     {/* Export Action Buttons */}
//                     <Grid
//                         item
//                         xs={12}
//                         md={4}
//                         sx={{
//                             display: "flex",
//                             justifyContent: { xs: "flex-start", md: "flex-end" },
//                             gap: 1,
//                         }}
//                     >
//                         <Tooltip title="Download PDF">
//                             <IconButton onClick={handleDownloadPdf}>
//                                 <img src={pdfImage} alt="pdf" style={{ width: 28, height: 28 }} />
//                             </IconButton>
//                         </Tooltip>

//                         <Tooltip title="Download Excel">
//                             <IconButton onClick={handleDownloadExcel}>
//                                 <img src={excelImage} alt="excel" style={{ width: 28, height: 28 }} />
//                             </IconButton>
//                         </Tooltip>
//                     </Grid>
//                 </Grid>
//             </Card>

//             {/* Loader */}
//             {loading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
//                     <CircularProgress />
//                 </Box>
//             ) : attendanceData.length === 0 ? (
//                 <Typography variant="body1" textAlign="center" sx={{ my: 4 }}>
//                     No records found.
//                 </Typography>
//             ) : isMobile ? (
//                 /* Mobile View - Card Layout */
//                 <Box>
//                     <Grid container spacing={2}>
//                         {paginatedData.map((emp, index) => (
//                             <Grid item xs={12} key={emp.employee_id}>
//                                 <Card sx={{ p: 2, borderRadius: '8px', boxShadow: 1, borderLeft: '4px solid #1976d2' }}>
//                                     <Typography variant="subtitle1" fontWeight="bold" color="primary.main">
//                                         {emp.employee_name}
//                                     </Typography>
//                                     <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
//                                         {emp.email || 'No Email'} | {emp.address}
//                                     </Typography>

//                                     <Grid container spacing={1} sx={{ mt: 1, pt: 1, borderTop: '1px solid #eee' }}>
//                                         <Grid item xs={4}><Typography variant="caption">Total: <b>{emp.total_days}</b></Typography></Grid>
//                                         <Grid item xs={4}><Typography variant="caption">Department: <b>{emp.department}</b></Typography></Grid>
//                                         <Grid item xs={4}><Typography variant="caption">Designation: <b>{emp.designation}</b></Typography></Grid>
//                                         <Grid item xs={4}><Typography variant="caption" color="success.main">Present: <b>{emp.present}</b></Typography></Grid>
//                                         <Grid item xs={4}><Typography variant="caption" color="error.main">Absent: <b>{emp.absent}</b></Typography></Grid>
//                                         <Grid item xs={4}><Typography variant="caption" color="warning.main">Leave: <b>{emp.leave}</b></Typography></Grid>
//                                         <Grid item xs={4}><Typography variant="caption" color="info.main">Holiday: <b>{emp.holiday}</b></Typography></Grid>
//                                     </Grid>
//                                 </Card>
//                             </Grid>
//                         ))}
//                     </Grid>

//                     <TablePagination
//                         component="div"
//                         count={attendanceData.length}
//                         page={page}
//                         onPageChange={handleChangePage}
//                         rowsPerPage={rowsPerPage}
//                         onRowsPerPageChange={handleChangeRowsPerPage}
//                         rowsPerPageOptions={[5, 10, 25]}
//                         sx={{ mt: 2 }}
//                     />
//                 </Box>
//             ) : (
//                 /* Desktop View - Table Layout */
//                 <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '12px', boxShadow: 2 }}>
//                     <TableContainer>
//                         <Table size="small">
//                             <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
//                                 <TableRow>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>S.No.</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>Employee Name</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>Address</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }} align="center">Department</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }} align="center">Designation</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }} align="center">Total Days</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold', color: 'success.main' }} align="center">Present</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold', color: 'error.main' }} align="center">Absent</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold', color: 'warning.main' }} align="center">Leave</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold', color: 'info.main' }} align="center">Holiday</TableCell>
//                                     <TableCell sx={{ fontWeight: 'bold' }}>Action</TableCell>

//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {paginatedData.map((emp, index) => (
//                                     <TableRow key={emp.employee_id} hover>
//                                         <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                                         <TableCell sx={{ fontWeight: 500 }}>{emp.employee_name}</TableCell>
//                                         <TableCell>{emp.email || '—'}</TableCell>
//                                         <TableCell sx={{ maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//                                             {emp.address}
//                                         </TableCell>
//                                         <TableCell align="center">{emp.designation}</TableCell>
//                                         <TableCell align="center">{emp.department}</TableCell>
//                                         <TableCell align="center">{emp.total_days}</TableCell>
//                                         <TableCell align="center" sx={{ color: 'success.main', fontWeight: 'bold' }}>{emp.present}</TableCell>
//                                         <TableCell align="center" sx={{ color: 'error.main', fontWeight: 'bold' }}>{emp.absent}</TableCell>
//                                         <TableCell align="center">{emp.leave}</TableCell>
//                                         <TableCell align="center">{emp.holiday}</TableCell>
//                                         <TableCell>
//                                             <Tooltip title="Download PDF">
//                                                 <IconButton onClick={() => handleDownloadSingleEmployeePdf(emp)}>
//                                                     <img src={pdfImage} alt="pdf" style={{ width: 28, height: 28 }} />
//                                                 </IconButton>
//                                             </Tooltip>
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>

//                     <TablePagination
//                         rowsPerPageOptions={[5, 10, 25]}
//                         component="div"
//                         count={attendanceData.length}
//                         rowsPerPage={rowsPerPage}
//                         page={page}
//                         onPageChange={handleChangePage}
//                         onRowsPerPageChange={handleChangeRowsPerPage}
//                     />
//                 </Paper>
//             )}
//         </Box>
//     );
// };

// export default AttendanceReport;





import React, { useState, useEffect } from 'react';
import {
    Card,
    Grid,
    TextField,
    InputAdornment,
    Tooltip,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Paper,
    TablePagination,
    Typography,
    Box,
    CircularProgress,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { Search } from '@mui/icons-material';
import dayjs from 'dayjs';

import CardHeadMenu from '../Components/Card/CardHeadMenu/CardHeadMenu';
import CustomDateRangePicker from "../Components/DatePicker/CustomDateRangePicker";

import pdfImage from "../Components/Assets/images/pdf.jfif";
import excelImage from "../Components/Assets/images/excel.png";
import configServ from '../services/config';
import { useSelector } from 'react-redux';
import DownloadAttendanceReportPdf from '../Components/Download/ DownloadAttendanceReportPdf';
import DownloadAttendanceReportExcel from '../Components/Download/DownloadAttendanceReportExcel';
import DownloadEmployeeAttendanceReportPdf from '../Components/Download/DownloadEmployeeAttendanceReportPdf';

// Dummy Imports (Apne path ke hisab se verify kar lein)
// import configServ from "../services/configServ"; 

const AttendanceReport = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Mobile/Tablet check

    // State Management
    const [attendanceData, setAttendanceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchCustomer, setSearchCustomer] = useState('');
    const { user_id, company_id, is_super, companyName } = useSelector(
        (state) => state.GlobalVariables,
    );
    // Default Date: 1st day of current month to Today
    const [dateRange, setDateRange] = useState([
        dayjs().startOf('month'),
        dayjs()
    ]);

    // Frontend Pagination States
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [companyLogo, setCompanyLogo] = useState("");
    const [openBackdrop, setOpenBackdrop] = useState(false);

    // Sorting state
    const [orderBy, setOrderBy] = useState('employee_name');
    const [order, setOrder] = useState('asc');

    const assignCompanyLogo = async () => {
        try {
            const result = await configServ.company_logo({ company_id: company_id });
            if (result && result.image) {
                // Assuming the result.image is already a base64 string
                setCompanyLogo(`data:image/png;base64,${result.image}`);
            } else {
                setCompanyLogo(null); // Set as null if no logo
            }
        } catch (e) {
            console.log(e);
            setCompanyLogo(null); // Handle error by clearing logo
        }
    };

    useEffect(() => {
        assignCompanyLogo();
    }, [company_id]);

    const fetchAttendanceReports = async () => {
        setLoading(true);
        try {
            // API payload schema as per your function
            const response = await configServ.getAttendanceReports({
                company_id: company_id,
                start_date: dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : "",
                end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
                search: searchCustomer,
                sort_by: orderBy,
                sort_order: order,
            });

            if (response && response.status) {
                setAttendanceData(response.data.data || response.data); // handles both formats
            }
        } catch (error) {
            console.error("Error:", error);
            setAttendanceData([]);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    };

    // Trigger API on dependencies change
    useEffect(() => {
        fetchAttendanceReports();
        setPage(0); // Reset page whenever filters change
    }, [dateRange, searchCustomer, order, orderBy]);

    // Pagination Handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Sorting Handler
    const handleSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // Button Handlers
    const handleDownloadPdf = () => {
        DownloadAttendanceReportPdf(attendanceData, companyName, companyLogo, setOpenBackdrop, dateRange);
    };
    const handleDownloadExcel = () => {
        DownloadAttendanceReportExcel(attendanceData, companyName, companyLogo, setOpenBackdrop, dateRange);
    };

    // Frontend local pagination logic
    const paginatedData = attendanceData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleDownloadSingleEmployeePdf = async (employeeData) => {
        try{
            setOpenBackdrop(true);
            const payload = {
                company_id: company_id,
                employee_id: employeeData.employee_id,
                start_date: dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : "",
                end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
            };
            const response = await configServ.employeeAttendanceReport(payload);
            if(response.status === 200)
            {
                DownloadEmployeeAttendanceReportPdf(response, companyName, companyLogo, setOpenBackdrop, dateRange);
            }

        } catch (error) {
            console.error("Error:", error);
            alert("Failed to download employee attendance report");
        } finally {
            setOpenBackdrop(false);
        }
    };

    return (
        <Box sx={{ p: 2, width: '100%' }}>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"ATTENDANCE Reports"}
                showCreate={false}
            />

            {/* Top Filter Header Card */}
            <Card
                sx={{
                    p: 2,
                    mb: 3,
                    borderRadius: "12px",
                    borderLeft: "6px solid #1976d2",
                    width: "100%",
                    boxShadow: 2
                }}
            >
                <Grid container spacing={2} alignItems="center">
                    {/* Search Field */}
                    {/* <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            fullWidth
                            label="Search Employee"
                            size="small"
                            value={searchCustomer}
                            onChange={(e) => setSearchCustomer(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search fontSize="small" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid> */}

                    {/* Date Range Picker */}
                    <Grid item xs={12} sm={6} md={4}>
                        <CustomDateRangePicker
                            value={dateRange}
                            onChange={setDateRange}
                            fullWidth
                        />
                    </Grid>

                    {/* Export Action Buttons */}
                    <Grid
                        item
                        xs={12}
                        md={4}
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", md: "flex-end" },
                            gap: 1,
                        }}
                    >
                        <Tooltip title="Download PDF">
                            <IconButton onClick={handleDownloadPdf}>
                                <img src={pdfImage} alt="pdf" style={{ width: 28, height: 28 }} />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Download Excel">
                            <IconButton onClick={handleDownloadExcel}>
                                <img src={excelImage} alt="excel" style={{ width: 28, height: 28 }} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card>

            {/* Loader */}
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
                    <CircularProgress />
                </Box>
            ) : attendanceData.length === 0 ? (
                <Typography variant="body1" textAlign="center" sx={{ my: 4 }}>
                    No records found.
                </Typography>
            ) : isMobile ? (
                /* Mobile View - Card Layout */
                <Box>
                    <Grid container spacing={2}>
                        {paginatedData.map((emp, index) => (
                            <Grid item xs={12} key={emp.employee_id}>
                                <Card sx={{ p: 2, borderRadius: '8px', boxShadow: 1, borderLeft: '4px solid #1976d2' }}>
                                    <Typography variant="subtitle1" fontWeight="bold" color="primary.main">
                                        {emp.employee_name}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                        {emp.email || 'No Email'} | {emp.address}
                                    </Typography>

                                    <Grid container spacing={1} sx={{ mt: 1, pt: 1, borderTop: '1px solid #eee' }}>
                                        <Grid item xs={4}><Typography variant="caption">Total: <b>{emp.total_days}</b></Typography></Grid>
                                        <Grid item xs={4}><Typography variant="caption">Department: <b>{emp.department}</b></Typography></Grid>
                                        <Grid item xs={4}><Typography variant="caption">Designation: <b>{emp.designation}</b></Typography></Grid>
                                        <Grid item xs={4}><Typography variant="caption" color="success.main">Present: <b>{emp.present}</b></Typography></Grid>
                                        <Grid item xs={4}><Typography variant="caption" color="error.main">Absent: <b>{emp.absent}</b></Typography></Grid>
                                        <Grid item xs={4}><Typography variant="caption" color="warning.main">Leave: <b>{emp.leave}</b></Typography></Grid>
                                        <Grid item xs={4}><Typography variant="caption" color="info.main">Holiday: <b>{emp.holiday}</b></Typography></Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                    <TablePagination
                        component="div"
                        count={attendanceData.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 25]}
                        sx={{ mt: 2 }}
                    />
                </Box>
            ) : (
                /* Desktop View - Table Layout */
                <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '12px', boxShadow: 2 }}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>S.No.</TableCell>

                                    <TableCell sx={{ fontWeight: 'bold' }} sortDirection={orderBy === 'employee_name' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'employee_name'}
                                            direction={orderBy === 'employee_name' ? order : 'asc'}
                                            onClick={() => handleSort('employee_name')}
                                        >
                                            Employee Name
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold' }} sortDirection={orderBy === 'email' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'email'}
                                            direction={orderBy === 'email' ? order : 'asc'}
                                            onClick={() => handleSort('email')}
                                        >
                                            Email
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold' }} sortDirection={orderBy === 'address' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'address'}
                                            direction={orderBy === 'address' ? order : 'asc'}
                                            onClick={() => handleSort('address')}
                                        >
                                            Address
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold' }} align="center" sortDirection={orderBy === 'department' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'department'}
                                            direction={orderBy === 'department' ? order : 'asc'}
                                            onClick={() => handleSort('department')}
                                        >
                                            Department
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold' }} align="center" sortDirection={orderBy === 'designation' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'designation'}
                                            direction={orderBy === 'designation' ? order : 'asc'}
                                            onClick={() => handleSort('designation')}
                                        >
                                            Designation
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold' }} align="center" sortDirection={orderBy === 'total_days' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'total_days'}
                                            direction={orderBy === 'total_days' ? order : 'asc'}
                                            onClick={() => handleSort('total_days')}
                                        >
                                            Total Days
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold', color: 'success.main' }} align="center" sortDirection={orderBy === 'present' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'present'}
                                            direction={orderBy === 'present' ? order : 'asc'}
                                            onClick={() => handleSort('present')}
                                            sx={{
                                                color: 'success.main !important',
                                                '& .MuiTableSortLabel-icon': { color: 'success.main !important' },
                                            }}
                                        >
                                            Present
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold', color: 'error.main' }} align="center" sortDirection={orderBy === 'absent' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'absent'}
                                            direction={orderBy === 'absent' ? order : 'asc'}
                                            onClick={() => handleSort('absent')}
                                            sx={{
                                                color: 'error.main !important',
                                                '& .MuiTableSortLabel-icon': { color: 'error.main !important' },
                                            }}
                                        >
                                            Absent
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold', color: 'warning.main' }} align="center" sortDirection={orderBy === 'leave' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'leave'}
                                            direction={orderBy === 'leave' ? order : 'asc'}
                                            onClick={() => handleSort('leave')}
                                            sx={{
                                                color: 'warning.main !important',
                                                '& .MuiTableSortLabel-icon': { color: 'warning.main !important' },
                                            }}
                                        >
                                            Leave
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold', color: 'info.main' }} align="center" sortDirection={orderBy === 'holiday' ? order : false}>
                                        <TableSortLabel
                                            active={orderBy === 'holiday'}
                                            direction={orderBy === 'holiday' ? order : 'asc'}
                                            onClick={() => handleSort('holiday')}
                                            sx={{
                                                color: 'info.main !important',
                                                '& .MuiTableSortLabel-icon': { color: 'info.main !important' },
                                            }}
                                        >
                                            Holiday
                                        </TableSortLabel>
                                    </TableCell>

                                    <TableCell sx={{ fontWeight: 'bold' }}>Action</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedData.map((emp, index) => (
                                    <TableRow key={emp.employee_id} hover>
                                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                        <TableCell sx={{ fontWeight: 500 }}>{emp.employee_name}</TableCell>
                                        <TableCell>{emp.email || '—'}</TableCell>
                                        <TableCell sx={{ maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {emp.address}
                                        </TableCell>
                                        <TableCell align="center">{emp.designation}</TableCell>
                                        <TableCell align="center">{emp.department}</TableCell>
                                        <TableCell align="center">{emp.total_days}</TableCell>
                                        <TableCell align="center" sx={{ color: 'success.main', fontWeight: 'bold' }}>{emp.present}</TableCell>
                                        <TableCell align="center" sx={{ color: 'error.main', fontWeight: 'bold' }}>{emp.absent}</TableCell>
                                        <TableCell align="center">{emp.leave}</TableCell>
                                        <TableCell align="center">{emp.holiday}</TableCell>
                                        <TableCell>
                                            <Tooltip title="Download PDF">
                                                <IconButton onClick={() => handleDownloadSingleEmployeePdf(emp)}>
                                                    <img src={pdfImage} alt="pdf" style={{ width: 28, height: 28 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={attendanceData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            )}
        </Box>
    );
};

export default AttendanceReport;